import { createBrowserRouter } from "react-router-dom";
import { fallbackRoutes } from "./fallbackRoutes";
import { homeRoutes } from "./homeRoutes";
import { operationalRoutes } from "./operationalRoutes";
import { authRoutes } from "./authRoutes";
import { RouteErrorBoundary } from "../shared/pages/RouteErrorBoundary";

const basename =
  import.meta.env.BASE_URL === '/' ? '/' : import.meta.env.BASE_URL.replace(/\/$/, '');

export const router = createBrowserRouter(
  [
    ...authRoutes,
    ...fallbackRoutes,
    ...homeRoutes,
    ...operationalRoutes,
  ].map(route => ({
    ...route,
    errorElement: <RouteErrorBoundary />,
  })),
  { basename }
);